export default __webpack_public_path__ + "static/media/office2-afterA-1024w.41e85e77.webp";